export function prefixCssWithId(css: string, id: string): string {
  // Prefix each selector in a CSS rule block with #id
  // This is a simple approach and may not cover all CSS edge cases.
  return css.replace(/(^|})\s*([^{}]+)\s*\{/g, (match, p1, selector) => {
    // Don't prefix @-rules (e.g., @media, @keyframes)
    if (selector.trim().startsWith('@')) return match;
    // Prefix each selector in a comma-separated list
    const prefixed = selector
      .split(',')
      .map((sel: string) => `#${id} ${sel.trim()}`)
      .join(', ');
    return `${p1} ${prefixed} {`;
  });
}
